import { c as compute_rest_props, s as subscribe } from "../../../../../chunks/utils.js";
import { c as create_ssr_component, g as getContext, s as spread, a as escape_attribute_value, b as escape_object, d as add_attribute, e as escape, v as validate_component, i as each } from "../../../../../chunks/ssr.js";
import { G as GeneralInfo, P as Photos, R as Reminder, T as Timeline, a as TimelineItem } from "../../../../../chunks/Photos.js";
import { E as EmployeeInfo, Q as Qualifications, T as TaxAndInsurance, B as BankAccount } from "../../../../../chunks/TaxAndInsurance.js";
import dayjs from "dayjs";
import { a as asValue } from "../../../../../chunks/lenkradDate.js";
import { B as Button } from "../../../../../chunks/Button.js";
import { T as Textarea } from "../../../../../chunks/Textarea.js";
import { E as ExclamationCircleSolid } from "../../../../../chunks/ExclamationCircleSolid.js";
import { I as IconSolid } from "../../../../../chunks/IconSolid.js";
import { I as InfoCircleSolid } from "../../../../../chunks/InfoCircleSolid.js";
import { C as CardLayout } from "../../../../../chunks/CardLayout.js";
import "../../../../../chunks/client.js";
import { M as Modal } from "../../../../../chunks/Modal2.js";
import { g as get } from "../../../../../chunks/api.js";
import { C as ClockOutline } from "../../../../../chunks/ClockOutline.js";
import { twMerge } from "tailwind-merge";
const DnaOutline = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$restProps = compute_rest_props($$props, ["size", "role", "color", "withEvents", "title", "strokeWidth", "desc", "ariaLabel"]);
  const ctx = getContext("iconCtx") ?? {};
  const sizes = {
    xs: "w-3 h-3",
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
    xl: "w-8 h-8"
  };
  let { size = ctx.size || "md" } = $$props;
  let { role = ctx.role || "img" } = $$props;
  let { color = ctx.color || "currentColor" } = $$props;
  let { withEvents = ctx.withEvents || false } = $$props;
  let { title = {} } = $$props;
  let { strokeWidth = ctx.strokeWidth || "2" } = $$props;
  let { desc = {} } = $$props;
  let ariaDescribedby = `${title.id || ""} ${desc.id || ""}`;
  let hasDescription = false;
  let { ariaLabel = "dna outline" } = $$props;
  if ($$props.size === void 0 && $$bindings.size && size !== void 0) $$bindings.size(size);
  if ($$props.role === void 0 && $$bindings.role && role !== void 0) $$bindings.role(role);
  if ($$props.color === void 0 && $$bindings.color && color !== void 0) $$bindings.color(color);
  if ($$props.withEvents === void 0 && $$bindings.withEvents && withEvents !== void 0) $$bindings.withEvents(withEvents);
  if ($$props.title === void 0 && $$bindings.title && title !== void 0) $$bindings.title(title);
  if ($$props.strokeWidth === void 0 && $$bindings.strokeWidth && strokeWidth !== void 0) $$bindings.strokeWidth(strokeWidth);
  if ($$props.desc === void 0 && $$bindings.desc && desc !== void 0) $$bindings.desc(desc);
  if ($$props.ariaLabel === void 0 && $$bindings.ariaLabel && ariaLabel !== void 0) $$bindings.ariaLabel(ariaLabel);
  {
    if (title.id || desc.id) {
      hasDescription = true;
    } else {
      hasDescription = false;
    }
  }
  return `${withEvents ? `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: "none" },
      { color: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"${add_attribute("stroke-width", strokeWidth, 0)} d="M15.041 13.862A4.999 4.999 0 0 1 17 17.831V21M7 3v3.169a5 5 0 0 0 1.891 3.916M17 3v3.169a5 5 0 0 1-2.428 4.288l-5.144 3.086A5 5 0 0 0 7 17.831V21M7 5h10M7.399 8h9.252M8 16h8.652M7 19h10"></path></svg>` : `<svg${spread(
    [
      { xmlns: "http://www.w3.org/2000/svg" },
      { fill: "none" },
      { color: escape_attribute_value(color) },
      escape_object($$restProps),
      {
        class: escape_attribute_value(twMerge("shrink-0", sizes[size ?? "md"], $$props.class))
      },
      { role: escape_attribute_value(role) },
      {
        "aria-label": escape_attribute_value(ariaLabel)
      },
      {
        "aria-describedby": escape_attribute_value(hasDescription ? ariaDescribedby : void 0)
      },
      { viewBox: "0 0 24 24" }
    ],
    {}
  )}>${title.id && title.title ? `<title${add_attribute("id", title.id, 0)}>${escape(title.title)}</title>` : ``}${desc.id && desc.desc ? `<desc${add_attribute("id", desc.id, 0)}>${escape(desc.desc)}</desc>` : ``}<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"${add_attribute("stroke-width", strokeWidth, 0)} d="M15.041 13.862A4.999 4.999 0 0 1 17 17.831V21M7 3v3.169a5 5 0 0 0 1.891 3.916M17 3v3.169a5 5 0 0 1-2.428 4.288l-5.144 3.086A5 5 0 0 0 7 17.831V21M7 5h10M7.399 8h9.252M8 16h8.652M7 19h10"></path></svg>`} `;
});
const EmployeeEmailStatusModal = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { open = false } = $$props;
  let { mailId = null } = $$props;
  let currentMailId = null;
  let status = null;
  if ($$props.open === void 0 && $$bindings.open && open !== void 0) $$bindings.open(open);
  if ($$props.mailId === void 0 && $$bindings.mailId && mailId !== void 0) $$bindings.mailId(mailId);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    {
      {
        if (mailId && mailId !== currentMailId) {
          currentMailId = mailId;
          get("/mail-retrieval/" + mailId).then((r) => status = r);
        }
      }
    }
    $$rendered = `${validate_component(Modal, "Modal").$$render(
      $$result,
      { title: "E-Mail Status", open },
      {
        open: ($$value) => {
          open = $$value;
          $$settled = false;
        }
      },
      {
        default: () => {
          return `${status ? `${each(status, (status2) => {
            return `<div class="grid grid-cols-2 gap-3"><div>${validate_component(ClockOutline, "ClockOutline").$$render($$result, {}, {}, {})}</div> <div>${escape(dayjs(status2.ArrivedAt).format("DD.MM.YYYY HH:mm"))}</div> <div>${validate_component(DnaOutline, "DnaOutline").$$render($$result, {}, {}, {})}</div> <div class="uppercase font-bold">${escape(status2.Status)}</div> <div data-svelte-h="svelte-11eap6a">Spam-Score</div> <div>${escape(status2.SpamassassinScore)}</div> <div data-svelte-h="svelte-g8u3bv">Versuche</div> <div>${escape(status2.AttemptCount + 1)}</div> </div>`;
          })}` : ``}`;
        }
      }
    )}`;
  } while (!$$settled);
  return $$rendered;
});
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $employee, $$unsubscribe_employee;
  const ICONS = [
    {
      type: "info",
      icon: InfoCircleSolid,
      color: "bg-primary-200 text-primary-600"
    },
    {
      type: "important",
      icon: ExclamationCircleSolid,
      color: "bg-red-200 text-red-600"
    }
  ];
  let employee = getContext("employee");
  $$unsubscribe_employee = subscribe(employee, (value) => $employee = value);
  getContext("super_edit");
  let mailStatusModal = false;
  let mailId = null;
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${$$result.head += `<!-- HEAD_svelte-3wfty0_START -->${$$result.title = `<title>${escape($employee.name)} </title>`, ""}<!-- HEAD_svelte-3wfty0_END -->`, ""} <div class="flex flex-col lg:flex-row gap-3"><div class="flex flex-col gap-7 xl:max-w-sm">${validate_component(GeneralInfo, "GeneralInfo").$$render($$result, { employee: $employee }, {}, {})} ${validate_component(CardLayout, "CardLayout").$$render(
      $$result,
      {
        title: $employee.employmentStatus !== "active" ? "Ich will ins Team weil..." : "Notiz",
        className: "sticky top-24"
      },
      {},
      {
        default: () => {
          return `${validate_component(Textarea, "Textarea").$$render(
            $$result,
            {
              disabled: true,
              rows: "4",
              value: $employee?.cv?.note
            },
            {},
            {}
          )}`;
        }
      }
    )} ${validate_component(Photos, "Photos").$$render($$result, { employee: $employee }, {}, {})}</div> <div class="flex flex-col 2xl:flex-row gap-3 w-full"><div class="flex flex-col w-full gap-7">${validate_component(Reminder, "Reminder").$$render($$result, {}, {}, {})} ${validate_component(EmployeeInfo, "EmployeeInfo").$$render($$result, {}, {}, {})} ${validate_component(Qualifications, "Qualifications").$$render($$result, {}, {}, {})} ${validate_component(TaxAndInsurance, "TaxAndInsurance").$$render($$result, {}, {}, {})} ${validate_component(BankAccount, "BankAccount").$$render($$result, {}, {}, {})}</div> <div class="max-w-sm w-full">${validate_component(CardLayout, "CardLayout").$$render(
      $$result,
      {
        display: false,
        className: "mb-4",
        title: "Add to Timeline",
        accordion: true
      },
      {},
      {
        default: () => {
          return `<form class="mb-7 flex flex-col gap-2" method="post" action="?/publish_to_timeline">${validate_component(Textarea, "Textarea").$$render(
            $$result,
            {
              id: "textarea-id",
              placeholder: "Your message",
              rows: "4",
              name: "content"
            },
            {},
            {}
          )} ${validate_component(Button, "Button").$$render(
            $$result,
            {
              type: "submit",
              class: "ml-auto",
              variant: "primary"
            },
            {},
            {
              default: () => {
                return `Add work log`;
              }
            }
          )}</form>`;
        }
      }
    )} <div class="px-7 mt-8">${validate_component(Timeline, "Timeline").$$render($$result, { order: "vertical", class: "w-full" }, {}, {
      default: () => {
        return `${each($employee.timeline.sort((a, b) => b.createdAt.stamp - a.createdAt.stamp), (timelineItem) => {
          let icon = ICONS.find((x) => x.type === timelineItem.type);
          return ` ${validate_component(TimelineItem, "TimelineItem").$$render(
            $$result,
            {
              title: timelineItem.type,
              date: dayjs(asValue(timelineItem.createdAt)).format("DD.MM.YYYY HH:mm")
            },
            {},
            {
              icon: () => {
                return `<span class="${"flex absolute -left-3 justify-center items-center w-6 h-6 " + escape(icon?.color, true) + " rounded-full ring-8 ring-white"}">${validate_component(IconSolid, "IconSolid").$$render($$result, { icon: icon?.icon, class: "w-3 h-3 " }, {}, {})}</span> `;
              },
              default: () => {
                return `<p class="text-gray-400 my- text-xs">${timelineItem.enteringEmployeeId ? `${escape(timelineItem?.enteringAssociations[0]?.firstName + " " + timelineItem?.enteringAssociations[0]?.lastName)}` : `System`}</p> <div class="mb-4 text-base font-normal text-gray-500 overflow-x-auto"><!-- HTML_TAG_START -->${timelineItem.content}<!-- HTML_TAG_END --></div> `;
              }
            }
          )}`;
        })}`;
      }
    })}</div></div></div></div> ${validate_component(EmployeeEmailStatusModal, "EmployeeEmailStatusModal").$$render(
      $$result,
      { mailId, open: mailStatusModal },
      {
        open: ($$value) => {
          mailStatusModal = $$value;
          $$settled = false;
        }
      },
      {}
    )}`;
  } while (!$$settled);
  $$unsubscribe_employee();
  return $$rendered;
});
export {
  Page as default
};
//# sourceMappingURL=_page.svelte.js.map
